module.exports = __webpack_public_path__ + "static/media/Ripple_Effect.a1d813cd.png";